import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Badge } from 'react-bootstrap-5';
import {
  Link,
  useRouteMatch
} from 'react-router-dom';

import { connect } from 'react-redux';
import { selectShadow } from 'bundles/project/actions';
import Tooltip from 'components/tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function SidebarLink({
  isGridTabDirty,
  selectShadow,
  to,
  tabData,
}) {
  const safeTo = to.startsWith('/') ? to : `/${to}`;
  const disabledTooltip = tabData.disabledTooltip;
  const actionIndicator = tabData.actionIndicator;
  const match = useRouteMatch({ path: safeTo });

  const isDisabled = typeof disabledTooltip === 'string';

  const disabledStyle = isDisabled ? { opacity: 0.5 } : undefined;

  function handleSidebarClick() {
    if (!isGridTabDirty && selectShadow) {
      selectShadow(null);
    }
  }

  const sidebarDivClass = classNames(
    'd-flex align-items-center mb-1 py-2 px-2 px-sm-3 rounded clickable text-capitalize',
    {
      'disabled': isDisabled,
      'bg-dark-subtle text-dark': !isDisabled && match,
      'text-muted': !isDisabled && !match,
    }
  );

  const sidebarContent = (
    <div className={sidebarDivClass} style={disabledStyle}>
      {tabData.badge && <Badge>{tabData.badge}</Badge>}
      {tabData.icon && <FontAwesomeIcon fixedWidth icon={tabData.icon}/>}
      <span className="w-100 d-none d-sm-inline ps-2 text-nowrap">
        {tabData.label || to}
        {tabData.isBeta && <span className="beta-label" name="betaLabel">BETA</span>}
      </span>

      {actionIndicator && actionIndicator.show && (
        <Tooltip content={tabData.actionIndicator.tooltip} dark={true} placement="right">
          <div className="action-indicator"/>
        </Tooltip>
      )}
    </div>
  );

  if (isDisabled) {
    return (
      <Tooltip content={disabledTooltip} dark={true} placement="right">
        <div>
          {sidebarContent}
        </div>
      </Tooltip>
    );
  }

  return (
    <Link
      className={classNames('sidebar-subtab', { active: match })}
      to={safeTo}
      onClick={handleSidebarClick}
    >
      {sidebarContent}
    </Link>
  );
}

SidebarLink.propTypes = {
  isGridTabDirty: PropTypes.bool,
  selectShadow: PropTypes.func,
  tabData: PropTypes.shape({
    badge: PropTypes.string,
    icon: PropTypes.object,
    label: PropTypes.string
  }).isRequired,
  to: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  isGridTabDirty: state.shadowGridTab && state.shadowGridTab.isDirty,
});

const mapDispatchToProps = {
  selectShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarLink);
